import useScrollToTop from './useScrollToTop';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import LiveMixes from './LiveMixes.js';
import StudioMixes from './StudioMixes.js';

function WorkSamples() {
    useScrollToTop();
    const { hash } = useLocation();
    const [selectedCategory, setSelectedCategory] = useState('all');

    useEffect(() => {
      if (hash) {
        const element = document.getElementById(hash.replace('#', ''));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }, [hash]);

    const handleSelectChange = (event) => {
        setSelectedCategory(event.target.value);
      };

      const renderSelectedCategory = () => {
        switch (selectedCategory) {
          case 'live-mixes':
            return <LiveMixes />;
          case 'studio-mixes':
            return <StudioMixes />;
          default:
            return (<div className='work-samples-default'>
                      <h2>choose a category to hear some samples of our work!</h2>
                      <div></div>
                    </div>);
        }
      };

      return (
        <div>
          <header className="worksamples-header">
            <h1>Work Samples</h1>
          </header>
          <div className="worksamples-body">
            <select className='custom-select' value={selectedCategory} onChange={handleSelectChange}>
              <option value="all">Select a category</option>
              <option value="live-mixes">Live Mixes</option>
              <option value="studio-mixes">Studio Mixes</option>
            </select>
            {renderSelectedCategory()}
          </div>
        </div>
      );}

export default WorkSamples;